import {Heading} from '@primer/react'
import {SidebarLink} from './SidebarLink'

interface SidebarResourceLinkProps {
  /** Octicon component to render before the label. */
  icon: React.ComponentType<{className?: string}>
  /** Display text for the link. */
  label: string
  /** Internal route path. */
  to?: string
  /** External or anchor URL. */
  href?: string
  /** Analytics label suffix, e.g. 'file:readme'. */
  analyticsLabel?: string
  /** Optional screen-reader-only heading above the link. */
  srHeading?: string
}

/** An icon + label link row used in the About section for resources and metadata. */
export function SidebarResourceLink({
  icon: Icon,
  label,
  to,
  href,
  analyticsLabel,
  srHeading,
}: SidebarResourceLinkProps) {
  return (
    <>
      {srHeading != null && (
        <Heading as="h3" className="sr-only">
          <span>{srHeading}</span>
        </Heading>
      )}
      <div className="mt-2">
        <SidebarLink to={to} href={href} muted analyticsLabel={analyticsLabel}>
          <Icon className="mr-2" />
          <span>{label}</span>
        </SidebarLink>
      </div>
    </>
  )
}
